<template>
  <div data-qa="price_free">
    <div class="d-flex align-center gc-3 mb-1">
      <div
        class="text-h6 text-success--text d-flex align-center gc-1"
        data-qa="price_free_text"
      >
        {{ t('Бесплатно', options) }}
        <img
          src="/static/_v1/pd/icons/ui-kit/promotion/tag-discount.svg"
          :alt="t('Иконка Акции', options)"
          width="20"
          height="20"
        >
      </div>
      <div
        class="text-body-2 text-secondary--text text-decoration-line-through"
        data-qa="price_free_num"
      >
        {{ getFormattedPrice(price) }}
      </div>
    </div>
    <div
      class="text-caption text--text"
      data-qa="price_free_desc"
    >
      {{ t('Консультация бесплатна при условии дальнейшего лечения. Подробности уточняйте в клинике.', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { getFormattedPrice } from 'www/utils'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{ price?: number | null }>()
</script>
